import { useTranslation } from 'react-i18next';

import type { CommunityProfile } from '~/api/community/types';

import { useUpdateCommunityProfileAnalytics } from '~/api/community';
import { ExternalLinkButton } from '~/components';

import { linkIcons, useCommunityProfileLinks } from '../community.utils';
import { footerItemStyle, footerStyle } from './CommunityProfileFooter.css';

type Props = {
  profile: CommunityProfile;
};

export const CommunityProfileFooter = ({ profile: { email, id, links } }: Props) => {
  const mutation = useUpdateCommunityProfileAnalytics('mail');
  const filteredLinks = useCommunityProfileLinks(links);

  const { t } = useTranslation(['community']);

  return (
    <footer className={footerStyle}>
      {filteredLinks.length > 0 &&
        filteredLinks.map(({ type, url }) => (
          <ExternalLinkButton
            aria-label={t(`community:profileCard.footer.${type}`)}
            className={footerItemStyle}
            href={/^https?:\/\//i.test(url) ? url : `https://${url}`}
            icon={linkIcons[type]}
            key={type}
          />
        ))}

      <ExternalLinkButton
        aria-label={t('community:profileCard.footer.mail')}
        className={footerItemStyle}
        href={`mailto:${email}`}
        icon="Mail"
        onClick={() => mutation.mutate(id)}
      />
    </footer>
  );
};
